import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, CircularProgress, Stack, Typography } from '@mui/material';
import Drawer from './Drawer';
import { Faq, NewFaq } from '@/types/faq';
import { EmptyState, SortableList } from '@/components';
import {
  useDeleteFaqMutation,
  useFetchFaqsQuery,
} from '@/features/organizations/api/faqApi';
import { skipToken } from '@reduxjs/toolkit/dist/query';

export const EMPTY_FAQ: NewFaq = {
  question: '',
  answer: '',
};

const OrganizationFaqs = () => {
  const [selectedFaq, setSelectedFaq] = useState<Faq | NewFaq>();
  const { organizationId } = useParams<{ organizationId: string }>();

  const { data, isLoading } = useFetchFaqsQuery(organizationId || skipToken);
  const [deleteFaq] = useDeleteFaqMutation();

  const handleDelete = (faqId: string) => {
    if (!organizationId || !faqId) return;
    deleteFaq({ organizationId, faqId });
  };

  const handleEdit = (faq: Faq) => {
    delete faq.label;
    setSelectedFaq(faq);
  };

  const handleReorder = (faq: Faq) => {
    console.log('🚀 ~ faq:', faq);
  };

  const onClose = () => {
    setSelectedFaq(undefined);
  };

  if (isLoading) {
    return (
      <Stack flex={1} justifyContent="center" alignItems="center">
        <CircularProgress />
      </Stack>
    );
  }

  if (!data) {
    return <EmptyState />;
  }

  return (
    <Stack spacing={3}>
      <Stack spacing={2} direction="row" alignItems="center">
        <Typography variant="h2" flex={1}>
          Preguntas Frecuentes
        </Typography>
        <Button
          size="large"
          color="success"
          fullWidth={false}
          onClick={() => setSelectedFaq(EMPTY_FAQ)}
        >
          Crear
        </Button>
      </Stack>

      <SortableList<Faq>
        items={data.map((faq) => ({
          ...faq,
          id: faq.id,
          label: faq.question,
        }))}
        onDelete={(_, deletefFaq: any) => handleDelete(deletefFaq.id)}
        onEdit={handleEdit}
        deleteConfirmation
      />

      <Drawer value={selectedFaq as Faq} onClose={onClose} />
    </Stack>
  );
};

export default OrganizationFaqs;
